import { Input, Button, Select, FormControl, FormLabel, Box, useToast } from "@chakra-ui/react";
import { useState, useEffect } from "react";
import { createOfflinePayment, getCompany } from "../../../Http/Index";

const OfflinePayment = () => {
  const toast = useToast();
  const [b2cCompanyId, setB2cCompanyId] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    amount: "",
    paymentDate: "",
    expiryDate: "",
    paymentMethod: "cash",
    paymentTransactionId: ""
  });

  useEffect(() => {
    getCompany().then((res) => {
      const b2c = res.data?.data?.find((c: any) => c.companyName === "B2C_CUSTOMER");
      if (b2c) setB2cCompanyId(b2c._id);
    }).catch(() => { });
  }, []);

  useEffect(() => {
    const now = new Date();
    const currentDateTime = now.toISOString().slice(0, 10);
    const oneYearLater = new Date(now);
    oneYearLater.setFullYear(oneYearLater.getFullYear() + 1);
    const expiryDateTime = oneYearLater.toISOString().slice(0, 10);

    setFormData(prev => ({
      ...prev,
      paymentDate: currentDateTime,
      expiryDate: expiryDateTime
    }));
  }, []);

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));

    if (name === "paymentDate" && value) {
      const paymentDate = new Date(value);
      const expiryDate = new Date(paymentDate);
      expiryDate.setFullYear(expiryDate.getFullYear() + 1);
      const expiryDateString = expiryDate.toISOString().slice(0, 10);
      setFormData(prev => ({ ...prev, expiryDate: expiryDateString }));
    }
  };

  const handleSubmit = async () => {
    if (!formData.email || !formData.amount || !formData.paymentDate || !formData.expiryDate) {
      toast({ title: "Validation Error", description: "All required fields must be filled", status: "warning", duration: 3000, isClosable: true });
      return;
    }
    setIsLoading(true);

    try {
      const payload = {
        email: formData.email,
        amount: Number(formData.amount),
        paymentDate: new Date(formData.paymentDate).toISOString(),
        expiryDate: new Date(formData.expiryDate).toISOString(),
        paymentMethod: formData.paymentMethod,
        paymentTransactionId: formData.paymentTransactionId,
        companyId: b2cCompanyId
      };

      await createOfflinePayment(payload);

      toast({
        title: "Success",
        description: "Offline payment created successfully",
        status: "success",
        duration: 3000,
        isClosable: true
      });

      setFormData({
        email: "",
        amount: "",
        paymentDate: "",
        expiryDate: "",
        paymentMethod: "cash",
        paymentTransactionId: ""
      });
    } catch (error: any) {
      toast({
        title: "Error",
        description: error?.response?.data?.message || "Failed to create offline payment",
        status: "error",
        duration: 3000,
        isClosable: true
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", marginRight: "20px", gap: "10px", marginTop: "30px" }}>
      <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
        <FormControl isRequired style={{ flex: "1 1 300px", maxWidth: "300px" }}>
          <FormLabel>Email Id</FormLabel>
          <Input
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Enter Email Id"
          />
        </FormControl>

        <FormControl isRequired style={{ flex: "1 1 300px", maxWidth: "300px" }}>
          <FormLabel>Amount</FormLabel>
          <Input
            name="amount"
            type="number"
            value={formData.amount}
            onChange={handleChange}
            placeholder="Enter amount"
          />
        </FormControl>

        <FormControl isRequired style={{ flex: "1 1 300px", maxWidth: "300px" }}>
          <FormLabel>Payment Date</FormLabel>
          <Input
            name="paymentDate"
            type="date"
            value={formData.paymentDate}
            onChange={handleChange}
          />
        </FormControl>

        <FormControl isRequired style={{ flex: "1 1 300px", maxWidth: "300px" }}>
          <FormLabel>Expiry Date</FormLabel>
          <Input
            name="expiryDate"
            type="date"
            value={formData.expiryDate}
            onChange={handleChange}
          />
        </FormControl>

        <FormControl isRequired style={{ flex: "1 1 300px", maxWidth: "300px" }}>
          <FormLabel>Payment Method</FormLabel>
          <Select
            name="paymentMethod"
            value={formData.paymentMethod}
            onChange={handleChange}
          >
            <option value="cash">Cash</option>
            <option value="cheque">Cheque</option>
            <option value="bank_transfer">Bank Transfer</option>
            <option value="upi">UPI</option>
          </Select>
        </FormControl>

        <FormControl style={{ flex: "1 1 300px", maxWidth: "300px" }}>
          <FormLabel>Payment Transaction ID</FormLabel>
          <Input
            name="paymentTransactionId"
            value={formData.paymentTransactionId}
            onChange={handleChange}
            placeholder="Enter transaction ID"
          />
        </FormControl>
      </div>

      <Box marginTop="10px" display="flex" justifyContent="center">
        <Button colorScheme="green" onClick={handleSubmit} isLoading={isLoading}>
          Submit Payment
        </Button>
      </Box>
    </div>
  );
};

export default OfflinePayment;
